function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "prefix__a",
  d: "M0.272 0.497L6.564 0.497 6.564 6.792 0.272 6.792z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0H48V48H0z",
  transform: "translate(.783 .5)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(.783 .5) translate(20.673 9.333)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "prefix__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#prefix__a"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#F6BF00",
  d: "M6.564 3.643c0 1.738-1.408 3.149-3.144 3.149-1.737 0-3.148-1.41-3.148-3.149C.272 1.905 1.682.496 3.42.496c1.736 0 3.144 1.41 3.144 3.147",
  mask: "url(#prefix__b)"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#1A171B",
  d: "M20.85 27.208h6.289v-1.585c0-.284-.241-.523-.524-.523h-5.241c-.285 0-.523.24-.523.523v1.585zm-7.345 6.251h20.989v-4.17H13.505v4.17zm-3.083-7.296c-.55 0-1.002.449-1.002 1.002v8.418c0 .554.451 1.003 1.002 1.003.553 0 1.003-.45 1.003-1.003v-8.418c0-.553-.45-1.002-1.003-1.002zm27.156 0c-.552 0-1.002.449-1.002 1.002v8.418c0 .554.45 1.003 1.002 1.003.553 0 1.002-.45 1.002-1.003v-8.418c0-.553-.45-1.002-1.002-1.002zm-13.08-7.246h3.68c.575 0 1.041.467 1.041 1.04 0 .576-.466 1.042-1.04 1.042H25.05v2.02h1.565c1.436 0 2.604 1.169 2.604 2.604v1.585h5.276v-.043c0-1.7 1.383-3.083 3.083-3.083 1.7 0 3.083 1.383 3.083 3.083v8.418c0 1.7-1.383 3.084-3.083 3.084-1.7 0-3.083-1.383-3.083-3.084v-.042h-20.99v.042c0 1.7-1.382 3.084-3.083 3.084-1.699 0-3.083-1.383-3.083-3.084v-8.418c0-1.7 1.384-3.083 3.083-3.083 1.701 0 3.083 1.383 3.083 3.083v.043h5.264v-1.585c0-1.435 1.169-2.603 2.605-2.603h1.595V21h-3.16c-.573 0-1.04-.467-1.04-1.042 0-.574.467-1.04 1.04-1.04h4.688z",
  transform: "translate(.783 .5)"
}));

var SvgIconConnection = function SvgIconConnection(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconConnection, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_connection.82fa579c.svg";
export { ForwardRef as ReactComponent };